import { render, staticRenderFns } from "./CmgCheckoutAddressInfo.vue?vue&type=template&id=2ca1a05a&scoped=true&lang=pug&"
import script from "./cmg-checkout-address-info.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-address-info.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutAddressInfo.vue?vue&type=style&index=0&id=2ca1a05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca1a05a",
  null
  
)

export default component.exports